import { calculateMessageMediaURL } from '../../../helper/mediaHelper';
import preloadImage from '../../../helper/preloadImage';
import { openMediaFullscreen } from '../../uiState/uiStateSlice';
import { getMessageMediaRelativePath } from '../messageSelector';

const openMessageMediaFullscreen =
  ({ messageId }) =>
  async (dispatch, getState) => {
    const mediaFileName = getMessageMediaRelativePath(messageId)(getState());
    const mediaFullscreenUrl = calculateMessageMediaURL(mediaFileName);
    await preloadImage(mediaFullscreenUrl);
    dispatch(openMediaFullscreen({ mediaFullscreenUrl }));
  };

export default openMessageMediaFullscreen;
